module.exports = __webpack_public_path__ + "img/212.291be2b2.jpg";